import { LogoutOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useAuthenticationContext } from './context'

export const LogoutButton = () => {
  const { session } = useAuthenticationContext()

  return (
    <Button icon={<LogoutOutlined />} onClick={session.logout}>
      Log out
    </Button>
  )
}
